import { render, staticRenderFns } from "./WardrobeSection.vue?vue&type=template&id=d590dbe2&"
import script from "./WardrobeSection.vue?vue&type=script&lang=js&"
export * from "./WardrobeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports